import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth, useSession } from "@hooks";

interface MenuAreaProps {
  isMobile: boolean;
  end: boolean;
}

const languagesVarsCodes = [
  "LANG_neobooking_customerarea", //Espace client
  "LANG_neobooking_partnerarea", //Espace partenaire
  "LANG_neobooking_proparea", //Espace propriétaire
];

const MenuArea: React.FC<MenuAreaProps> = ({ isMobile, end }) => {
  /* Hooks */
  const location = useLocation();
  const { user } = useAuth();
  const { getLanguageVarValue } = useSession();

  /**
   * It checks if the current path starts with the area.
   * @param {"user" | "partner" | "owner"} area - The area of the page that the user is currently in.
   * @returns A boolean value.
   */
  const isInArea = (area: "user" | "partner" | "owner") => {
    return location.pathname.startsWith(`/${area}`);
  };

  let to = "/user";
  let name = getLanguageVarValue("LANG_neobooking_customerarea");
  let className = isMobile
    ? classNames(
        isInArea("user") ? "tw-text-primary-500 tw-bg-gray-100" : "",
        "tw-py-2 tw-rounded tw-text-base tw-px-3 tw-font-medium focus:tw-outline-none tw-cursor-pointer hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out"
      )
    : "tw-text-sm tw-rounded tw-px-3 tw-py-2 tw-font-medium focus:tw-outline-none tw-cursor-pointer tw-bg-primary-500 tw-text-white hover:tw-bg-primary-400 tw-transition-colors tw-duration-200 tw-ease-in-out";

  /*if (user?.clientType?.id === 2) {
    to = "/partner";
    name = getLanguageVarValue("LANG_neobooking_partnerarea")
  }

  if (user?.clientType?.id === 4 || user?.clientType?.id === 5) {
    to = "/owner";
    name = getLanguageVarValue("LANG_neobooking_proparea")
  }*/

  return (
    <NavLink to={to} className={className} end={end}>
      {name}
    </NavLink>
  );
};

MenuArea.propTypes = {
  //
};

export default MenuArea;
